import { handleStorageFactory } from './handle-storage-factory';

export const { get, set, remove } = handleStorageFactory(window.localStorage);
